module.exports = __webpack_public_path__ + "img/portrait.d3ba69e7.jpg";